/* eslint-disable max-len */

import { FC, useState } from 'react';
import { Popover, Tooltip } from 'antd';
import { Reaction } from 'utils/reaction';
import { TbMoodPlus } from 'react-icons/tb';
import { EmojiPicker } from 'components/EmojiPicker';
import useCommentReactions from '../../hooks/useCommentReactions';
import styles from './styles.module.less';

interface CommentReactionOptionsProps {
  data: any;
  onAddReaction: (reaction: Reaction) => void;
  onRemoveReaction: (reaction: Reaction) => void;
  onVisibleChange?: (visible: boolean) => void;
  alwaysShow?: boolean;
}

const CommentReactionOptions: FC<CommentReactionOptionsProps> = ({ data, onAddReaction, onRemoveReaction, onVisibleChange, alwaysShow }) => {
  const { addReact, removeReact, hasUserReaction } = useCommentReactions({
    initialData: data,
    onReactAdd: onAddReaction,
    onReactRemove: onRemoveReaction,
  });

  const [showPopover, setShowPopover] = useState(false);

  const handleReactionToggle = (emojiId: string) => {
    if (hasUserReaction(emojiId)) {
      removeReact(emojiId);
    } else {
      addReact(emojiId);
    }
  };

  const popoverContent = (
    <div ref={(ref) => {
      if (ref) ref.onclick = (e) => e.stopPropagation();
    }}>
      <EmojiPicker
        onSelect={(emoji) => {
          handleReactionToggle(emoji.id);
          setShowPopover(false);
          onVisibleChange?.(false);
        }}
      />
    </div>
  );

  return (
    <div className={`${styles.reactionContainer} ${(showPopover || alwaysShow) ? '' : styles.actionHoverContainer}`}>
      <Popover
        placement="bottom"
        content={popoverContent}
        trigger="click"
        visible={showPopover}
        onVisibleChange={(v) => { setShowPopover(v); onVisibleChange?.(v); }}
        overlayClassName={`no-padding-popover ${styles.emojiPortal}`}
      >
        <Tooltip title="Add reaction">
          <TbMoodPlus size={20} style={{ cursor: 'pointer' }} />
        </Tooltip>
      </Popover>
    </div>
  );
};

export default CommentReactionOptions;
